// Flujo login/consent de la Puerta 2 (OAuth Hydra) — plan MCP fase 6b.
// skipAuthRedirect: los 403 acá son "credenciales inválidas / acceso no
// habilitado" y se muestran en la página — sin esto el interceptor global
// de api.js hard-redirige a /go-to-plan.
import { requestWithoutToken } from "@/api/api";

export const acceptMcpLogin = (email, password, loginChallenge) =>
	requestWithoutToken.post(
		"/mcp/login/accept",
		{ email, password, login_challenge: loginChallenge },
		{ skipAuthRedirect: true },
	);

// Login del flow SIN password: la sesión de la app (JWT, que el interceptor
// de api.js adjunta solo) es la prueba de identidad. Solo llamarla con
// hasLiveSession() — una sesión vencida haría que el interceptor mate el
// request y redirija a "/".
export const acceptMcpLoginWithSession = (loginChallenge) =>
	requestWithoutToken.post(
		"/mcp/login/accept-session",
		{ login_challenge: loginChallenge },
		{ skipAuthRedirect: true },
	);

export const getMcpConsentContext = (consentChallenge) =>
	requestWithoutToken.get("/mcp/consent/context", {
		params: { consent_challenge: consentChallenge },
		skipAuthRedirect: true,
	});

export const acceptMcpConsent = (consentChallenge, companyId = null) =>
	requestWithoutToken.post(
		"/mcp/consent/accept",
		{
			consent_challenge: consentChallenge,
			...(companyId != null ? { company_id: companyId } : {}),
		},
		{ skipAuthRedirect: true },
	);
